import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

const navItems = [
  { label: "首页", to: "/" },
  { label: "热点聚合", to: "/topics" },
  { label: "关于我们", to: "/about" },
  { label: "常见问题", to: "/faq" },
  { label: "联系我们", to: "/contact" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const location = useLocation();

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 cursor-pointer" onClick={() => setMenuOpen(false)}>
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
              17
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">爆料网</span>
              <span className="mt-0.5 text-[11px] text-foreground-500">热点材料整理</span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="relative" onMouseEnter={() => setCatOpen(true)} onMouseLeave={() => setCatOpen(false)}>
              <button
                type="button"
                aria-expanded={catOpen}
                className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950 cursor-pointer"
              >
                分类
                <i className={`ri-arrow-down-s-line text-base transition-transform ${catOpen ? "rotate-180" : ""}`}></i>
              </button>
              {catOpen && (
                <div className="absolute right-0 top-full w-64 pt-1">
                  <ul className="overflow-hidden rounded-lg border border-background-200 bg-background-50 py-1 shadow-none">
                    {categories.map((cat) => (
                      <li key={cat.id}>
                        <Link
                          to={`/topics?cat=${cat.id}`}
                          className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950 cursor-pointer"
                        >
                          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                            <i className={`${cat.icon} text-base`}></i>
                          </span>
                          {cat.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/contact"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer md:inline-flex"
            >
              提供线索
            </Link>
            <button
              type="button"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer lg:hidden"
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={`rounded-md px-3 py-3 text-sm transition-colors cursor-pointer ${
                  isActive(item.to)
                    ? "bg-primary-100 font-medium text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="mt-2 border-t border-background-200 pt-3">
              <p className="px-3 pb-1 text-xs font-medium text-foreground-500">内容分类</p>
              <div className="grid grid-cols-2 gap-2 pt-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/topics?cat=${cat.id}`}
                    onClick={() => setMenuOpen(false)}
                    className="flex items-center gap-2 rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-200 cursor-pointer"
                  >
                    <i className={`${cat.icon} text-base text-secondary-600`}></i>
                    <span className="whitespace-nowrap">{cat.name}</span>
                  </Link>
                ))}
              </div>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}